import RunStateBadge from "components/Run/elements/StateBadge";
import TableSimpleCell from "ds/components/TableSimple/Cell";
import { TableSimpleCellProps } from "ds/components/TableSimple/types";

import { ModuleVersionTestCaseRow } from "../types";

const ModuleVersionTestCasesTableStatusCell = ({
  item: testCase,
  ...cellProps
}: TableSimpleCellProps<ModuleVersionTestCaseRow>) => {
  return (
    <TableSimpleCell {...cellProps}>
      <RunStateBadge state={testCase.state} />
    </TableSimpleCell>
  );
};

export default ModuleVersionTestCasesTableStatusCell;
